<template>
	<card class="weighing-form">
		<card-header class="bg-main">
			<div class="tw-p-8 tw-flex tw-justify-between tw-items-center">
				<p class="text-info text-base tw-m-0">Valora este Factor:</p>
				<countdown-timer ref="countdownTimer" @countdownFinished="onCountdownFinished" />
			</div>
		</card-header>
		<card-sub-header>
			<div class="tw-p-12">
				<weighing-factor-slider
					:factor-name="selectedFactor.name"
					:factor-image="selectedFactor.urlImage"
					@weighingAssignationChange="onWeighingAssignationChange"
					@sliderInteraction="startCountdown"
					ref="weighingFactorSlider"
				/>
			</div>
		</card-sub-header>
		<card-sub-header class="bg-main">
			<div class="tw-p-8">
				<p class="text-info text-base tw-m-0">Sobre este Factor:</p>
			</div>
		</card-sub-header>
		<weighing-factors-navigation
			:weighing-value="weighingAssignation.comparedFactorAssign"
			:pivot-factor-name="pivotFactor.name"
			:pivot-factor-url-image="pivotFactor.urlImage"
			:has-next="hasNextCompareNavigation"
			:has-prev="hasPrevCompareNavigation"
			@onPrevClick="goPrevFactor"
			@onNextClick="goNextFactor"
		/>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import CardHeader from '@/modules/shared/components/ui/Card/CardHeader';
import CardFooter from '@/modules/shared/components/ui/Card/CardFooter';
import CardSubHeader from '@/modules/shared/components/ui/Card/CardSubHeader';
import Countdown from '@/components/shared/countdown';
import CountdownTimer from '@/modules/shared/components/business/CountdownTimer';
import WeighingFactorSlider
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorSlider';
import WeighingFactorsNavigation
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorsNavigation';
import { isEmpty, isNil, prop } from 'ramda';

export default {
	name: 'WeighingForm',
	components: {
		WeighingFactorsNavigation,
		WeighingFactorSlider,
		CountdownTimer,
		Countdown,
		CardSubHeader,
		CardFooter,
		CardHeader,
		Card,
	},
	props: ['selectedFactor', 'selectedFactors', 'combinations', 'enabledCountdown', 'factorsToCompare'],
	data() {
		return {
			weighingAssignation: {
				factorAssign: 0,
				comparedFactorAssign: 0,
			},
			pivotFactor: {},
			pivotIndex: 0,
		};
	},
	methods: {
		onCountdownFinished() {
			this.goNextFactor();
		},
		startCountdown() {
			if (this.enabledCountdown) {
				this.$refs.countdownTimer.startCountdown();
			}
		},
		onWeighingAssignationChange(assignation) {
			this.updateWeighingAssignation(assignation, this.pivotFactor);
		},
		updateWeighingAssignation(assignation, pivot) {
			this.weighingAssignation = assignation;
			this.pivotFactor = pivot;
			if (assignation.factorAssign && !isEmpty(pivot)) {
				const newCombination = {
					[this.selectedFactor.uuid]: assignation.factorAssign,
					[this.pivotFactor.uuid]: assignation.comparedFactorAssign,
				};
				this.$store.dispatch('jobEvaluation/updateCombination', newCombination);
			}
		},
		goPrevFactor() {
			this.updatePivotFactor(this.pivotIndex - 1);
		},
		goNextFactor() {
			this.updatePivotFactor(this.pivotIndex + 1);
		},
		updatePivotFactor(index) {
			this.pivotIndex = index;
			this.pivotFactor = prop(index, this.selectedFactor.weighWith);
			// eslint-disable-next-line no-unused-expressions
			this.$refs.countdownTimer && this.$refs.countdownTimer.resetCountdown();
			// eslint-disable-next-line no-unused-expressions
			this.$refs.weighingFactorSlider && this.$refs.weighingFactorSlider.reset();
			this.updateWeighingAssignation(this.weighingAssignation, this.pivotFactor);
			this.$emit('comparePivotIndexChange', index);
		},
	},
	computed: {
		hasNextCompareNavigation() {
			return !isNil(prop(this.pivotIndex + 1, this.selectedFactor.weighWith));
		},
		hasPrevCompareNavigation() {
			if ((this.pivotIndex - 1) < 0) return false;
			return !isNil(prop(this.pivotIndex - 1, this.selectedFactor.weighWith));
		},
	},
	watch: {
		selectedFactor: {
			handler(nextValue, prevValue = {}) {
				if (nextValue.uuid !== prevValue.uuid) {
					this.updatePivotFactor(0);
				}
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.weighing-form {
	margin-right: 30px;
	margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingForm.vue